<button
  type="button"
  class="{{ buttonStyleClass() }}"
  alg-button
  [icon]="caretIcon()"
  [attr.aria-label]="triggerAriaLabel() ?? null"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="isOpen.set(!isOpen())"
>
  <ng-content select="[algSelectTrigger]" />
  @if (!hasCustomTrigger()) {
    @if (selected()?.label; as label) {
      <span class="select-button-label">{{ label }}</span>
    }
  }
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayPositions]="positions()"
  [cdkConnectedOverlayLockPosition]="true"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  (overlayOutsideClick)="isOpen.set(false)"
>
  <div
    class="dropdown"
    [class.open-above]="openAbove()"
    [style.minWidth.px]="el.nativeElement.getBoundingClientRect().width"
  >
    <ng-content />
  </div>
</ng-template>
